import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { FAQS, BRAND } from "@/lib/site";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-blue-600">
            FAQ
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
            Answers to the questions we hear every day.
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Still not sure? Call us at{" "}
            <a
              href={BRAND.phoneHref}
              className="font-semibold text-blue-600 hover:text-blue-700"
            >
              {BRAND.phone}
            </a>{" "}
            — we're happy to confirm exactly what you'll need before you come in.
          </p>

          <div className="mt-10 hidden lg:flex items-center gap-3 text-slate-500">
            <HelpCircle className="h-5 w-5 text-blue-600" />
            <span className="text-sm">Can't find your question? Just ask.</span>
          </div>
        </div>

        <div className="lg:col-span-7" data-testid="faq-accordion-wrap">
          <Accordion
            type="single"
            collapsible
            className="rounded-2xl border border-slate-200 bg-white divide-y divide-slate-200 overflow-hidden"
          >
            {FAQS.map((f, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                data-testid={`faq-item-${idx}`}
                className="border-0"
              >
                <AccordionTrigger className="px-6 py-5 text-left font-display text-lg font-semibold text-slate-900 hover:no-underline hover:bg-slate-50 transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-[15px] text-slate-600 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
